import { noop } from "lodash";
import { usePunditUserContext } from "@/react/contexts";
import { useAttendeeSeatsAddon } from "./useAttendeeSeatsAddon";
import { useRecordingHoursAddon } from "./useRecordingHoursAddon";
import { useStreamHoursAddon } from "./useStreamHoursAddon";

export const useLiveStreamsAddonsQuantities = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isConsolidateRecordingsInMediaManagerEnabled =
    currentCommunitySettings?.consolidate_recordings_in_media_manager_enabled;
  const {
    isLoading: isLoadingRecordingHoursAddon,
    currentQuantity: recordingHoursAddonQuantity,
    refetch: refetchRecordingHours,
  } = useRecordingHoursAddon(noop, {
    enabled: !isConsolidateRecordingsInMediaManagerEnabled,
  });
  const {
    isLoading: isLoadingStreamHoursAddon,
    currentQuantity: streamHoursAddonQuantity,
    refetch: refetchStreamHours,
  } = useStreamHoursAddon();
  const {
    isLoading: isLoadingAttendeeSeatsAddon,
    currentQuantity: attendeeSeatsAddonQuantity,
    refetch: refetchAttendees,
  } = useAttendeeSeatsAddon();

  const isLoading =
    isLoadingRecordingHoursAddon ||
    isLoadingStreamHoursAddon ||
    isLoadingAttendeeSeatsAddon;
  const refetch = () => {
    // We will refetch all the addon quantities
    void refetchRecordingHours();
    void refetchStreamHours();
    void refetchAttendees();
  };

  return {
    recordingHoursAddonQuantity,
    streamHoursAddonQuantity,
    attendeeSeatsAddonQuantity,
    isLoading,
    refetch,
  };
};
